<template>
    <el-dialog
        class="scroll-dialog"
        title="图片裁剪"
        :visible.sync="cropperVisible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="450px"
    >
        <div class="flex">
            <div class="img-box">
                <img class="cropper-image" :id="imgId" alt="" />
            </div>
            <div v-if="preview" class="preview-box" :id="previewId"></div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="reset">重新选取</el-button>
            <el-button type="primary" @click="submit">
                确 定
            </el-button>
        </span>
    </el-dialog>
</template>
<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.min.css';
export default {
    name: 'cropper',
    props: {
        visible: {
            type: Boolean,
            default: () => false
        },
        preview: {
            type: Boolean,
            default: true
        },
        src: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            cropper: null
        };
    },
    computed: {
        cropperVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit('update:visible', val);
            }
        },
        imgId() {
            return `cropper${this._uid}`;
        },
        previewId() {
            return `cropper_preview${this._uid}`;
        }
    },
    watch: {
        cropperVisible: {
            handler: function(val) {
                if (val && !this.cropper) {
                    this.$nextTick(() => {
                        const dom = document.getElementById(this.imgId);
                        this.cropper = new Cropper(dom, {
                            preview: `#${this.previewId}`,
                            checkCrossOrigin: true,
                            aspectRatio: 1 / 1
                        });
                        this.src && this.cropper.replace(this.src);
                    });
                }
            },
            immediate: true,
            deep: true
        },
        src(val) {
            if (this.cropper && val) {
                this.cropper.replace(val);
            }
        }
    },
    methods: {
        reset() {
            this.$emit('reset');
        },
        submit() {
            this.cropper.getCroppedCanvas().toBlob(blob => {
                this.$emit('on-crop', blob, `${this._uid}.png`);
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.img-box {
    width: 300px;
    height: 300px;
    border: 1px solid #ebebeb;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}
.preview-box {
    margin-left: 10px;
    height: 104px;
    width: 104px;
    overflow: hidden;
    border: 1px solid #ebebeb;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}
</style>
